module.exports = __webpack_public_path__ + "img/104.0a4aa8e0.jpg";